import Vue from 'vue'
import store from 'store'
import qs from 'qs'

export default {
    createQuestion(rootState, templateId, newQuestion, position, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La création de la question a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "label": newQuestion.label,
            "position": position,
            "answerType": newQuestion.answerType
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/" + templateId + "/survey-question/create", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    updateQuestion(rootState, templateId, newQuestion, position, callbacks)   {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La mise à jour de la question a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "label": newQuestion.label,
            "position": position,
            "answerType": newQuestion.answerType
        })});

        Vue.axios.post(rootState.baseUrl + "/admin/template/" + templateId + "/survey-question/update/" + newQuestion.id, params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    deleteQuestion(rootState, questionId, callbacks)	{
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La suppression de la question a échoué.",
                type: 'danger'
            });
        };

	    Vue.axios.delete(rootState.baseUrl + "/admin/criteria/delete/" + criteriaId, {headers: rootState.headers}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success();
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    },
    setSurveyQuestionAnswer(rootState, instanceId, selectedAnswer, nextSurveyQuestionPosition, last, callbacks) {
        let defaultFailErrorCallback = function ()  {
            store.commit('ALERT_DATA_UPDATED', {
                text: "La sauvegarde de la réponse a échoué.",
                type: 'danger'
            });
        };

        let params = qs.stringify({"data": JSON.stringify({
            "choice": selectedAnswer,
            "nextSurveyQuestionPosition": nextSurveyQuestionPosition,
            "last": last
        })});
        Vue.axios.post(rootState.baseUrl + "/user/instance/" + instanceId + "/set-survey-question-answer", params, {"headers": rootState.postHeaders}).then((response) => {
            if (response.data.success)  {
                if (callbacks.success)  {
                    callbacks.success(response.data.id);
                }
                return true;
            }
            if (callbacks.fail)  {
                callbacks.fail();
            }
            defaultFailErrorCallback();
            return false;
        }).catch((err) => {
            if (callbacks.error)  {
                callbacks.error();
            }
            defaultFailErrorCallback();
            return false;
        });
    }
};